export default __webpack_public_path__ + "static/media/254.ff83e303.jpg";